import { atom } from "jotai";

export const openModalSolicitarBeneficioAtom = atom(false);
export const beneficiosAtom = atom([]);
export const beneficiosPendientesAprobacionAtom = atom([]);
export const loadingAtom = atom(false);

export const beneficiosHistoricoAtom = atom([]);

export const openModalRechazarBeneficioAtom = atom(false);
export const beneficioSeleccionadoAtom = atom(undefined);